import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Link from "../link";

// Components
import BlockContent from "../richText";
import CustomGatsbyImage from "../gatsbyImage";

// Constants
import RICH_TEXT_TYPES from "../../constants/richTextTypes";

// Helpers
import generateRandomId from "../../helpers/generateRandomId";

// Styles
import * as styles from "./textImage.module.scss";
import * as stylesImgSize from "../richText/style.module.scss";

const TextImage = (props) => {
  const { imageAlignment, imageData, richText, className } = props;
  const components = [
    <div className={styles.gridTextImgWrapper} key={generateRandomId()} style={{ display: "block" }}>
      {imageData.imageUrl && <Link className={styles.gridTextImgLink} url={imageData.imageUrl} />}
      <CustomGatsbyImage
        alt={imageData.alt}
        imgClassName={cx({
          [stylesImgSize[`reachCustomImg${imageData.imgSize}`]]:
            imageData?.imgSize,
          [stylesImgSize[`img${imageData?.positionImg || "Center"}`]]:
            imageData?.imgSize !== "100",
        })}
        img={imageData.image.asset}
      />
    </div>,
    <div className={styles.pageBuilderContent} key="right">
      {(richText ?? []).map((blocks) => {
        const blockClassName = cx({
          [styles.pageBuilderButton]:
            blocks._type === RICH_TEXT_TYPES.buttonLink,
          [styles.pageBuilderImage]:
            blocks._type === RICH_TEXT_TYPES.customImage,
        });
        return (
          <BlockContent
            blocks={blocks}
            customClassName={blockClassName}
            key={blocks._key}
          />
        );
      })}
    </div>,
  ];
  return (
    <div className={styles.textImageWrapper}>
      <div className={cx(styles.gridImgTextContainer, className)}>
        {imageAlignment === "left"
          ? components.map((component) => component)
          : components.reverse().map((component) => component)}
      </div>
    </div>
  );
};

TextImage.propTypes = {
  imageAlignment: PropTypes.oneOf(["left", "right"]),
  imageData: PropTypes.shape({
    alt: PropTypes.string,
    image: PropTypes.shape({
      asset: PropTypes.object,
    }),
  }).isRequired,
  richText: PropTypes.array,
};

TextImage.defaultProps = {
  imageAlignment: "right",
  richText: [],
};

export default TextImage;
